function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#52B0C3",
  d: "M9 0v1.191c-1 .298-2 1.193-2 2.782 0 1.887 1.6 2.483 2.6 2.88 1.2.497 1.4.596 1.4 1.092 0 .497-.2.994-1 .994s-1-.497-1-.994H7c0 .994.6 2.385 2 2.782v1.191h2v-1.19c1.4-.398 2-1.79 2-2.783 0-1.887-1.6-2.483-2.6-2.88C9.2 4.568 9 4.469 9 3.973c0-.795.5-.993 1-.993.8 0 1 .496 1 .993h2c0-.993-.6-2.385-2-2.782V0H9zM3 .993v9.932H2c-1.093 0-2 .9-2 1.986v5.96h2v-5.96h1c0 1.098.895 1.987 2 1.987h10c1.105 0 2-.89 2-1.987h1v5.96h2v-5.96c0-1.085-.907-1.986-2-1.986h-1V.993h-2v11.918H5V.993H3zm2 15.891v1.986h2v-1.986H5zm4 0v1.986h2v-1.986H9zm4 0v1.986h2v-1.986h-2z"
});

var SvgInvoiceReceiptOutline = function SvgInvoiceReceiptOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvoiceReceiptOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/invoice-receipt-outline.2a13e8b0.svg";
export { ForwardRef as ReactComponent };